<div class="modal-header" id="participant-copies-modal-title">
    <h3 class="modal-title" id="modal-title">Historical values</h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>

<table class="table text-center">
    <thead>
        <tr>
            <th scope="col">Value recorded</th>
            <th scope="col">Date</th>
        </tr>
    </thead>
    <tbody>
        @for (historicalValue of historicalValues$ | async; track historicalValue.date) {
            <tr>
                <td>{{ historicalValue.value }}</td>
                <td>{{ historicalValue.date }}</td>
            </tr>
        }
    </tbody>
</table>
<div class="modal-footer">
    <button type="button" [disabled]="disableLoadMoreButton$ | async" (click)="loadAllValues()" class="btn btn-primary">
        Load all values
    </button>
</div>
